import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

// Topic cross-links (labs / articles / Q&A) — descriptive anchors, not "read more".
export default function RelatedContent({ query, exclude = "", className = "" }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!query) return;
        api.get(`/related-content?q=${encodeURIComponent(query)}&exclude=${encodeURIComponent(exclude)}`)
            .then(({ data }) => setData(data))
            .catch(() => {});
    }, [query, exclude]);

    if (!data) return null;
    const rows = [
        ...data.labs.map((l) => ({ ...l, kind: "lab", anchor: `Practice this in a legal lab: ${l.title}`, color: "#4ade80" })),
        ...data.articles.map((a) => ({ ...a, kind: "article", anchor: `Read the writeup: ${a.title}`, color: "#22d3ee" })),
        ...data.questions.map((q) => ({ ...q, kind: "qa", anchor: `Community Q&A: ${q.title}`, color: "#38bdf8" })),
    ];
    if (rows.length === 0) return null;
    return (
        <section className={`hc-surface border border-white/10 rounded-md p-4 ${className}`} data-testid="related-content" aria-label="Related content">
            <h2 className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2.5">// go deeper</h2>
            <ul className="space-y-1">
                {rows.slice(0, 6).map((r) => (
                    <li key={r.path}>
                        <Link to={r.path} data-testid={`related-link${r.path.replace(/\//g, "-")}`}
                              className="group flex items-baseline gap-2 py-1 text-[13px] text-slate-300 hover:text-white transition-colors">
                            <span className="font-mono text-[10px] font-bold shrink-0" style={{ color: r.color }} aria-hidden="true">
                                {r.kind === "lab" ? "⚑" : r.kind === "article" ? "◆" : "?"}
                            </span>
                            <span className="">{r.anchor}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </section>
    );
}
